import apiV2 from '@/api/v2';
export const getUnifiedOffersList = async (params) => {
    const { data } = await apiV2.get('/unified-offers', {
        params,
    });
    return data;
};
